<template>
  <div style="height: 400px; max-width: 100%; width: 99%;">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import { Bar } from 'vue-chartjs'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'GroupedBarChart',
  components: { Bar },
  props: {
    labels: { type: Array, required: true },
    efectivo: { type: Array, required: true },
    debito: { type: Array, required: true },
    credito: { type: Array, required: true },
    deposit: { type: Array, required: true },
    transfer: { type: Array, required: true }
  },
  computed: {
    chartData () {
      const rawDatasets = [
        { label: 'Efectivo', data: this.efectivo, backgroundColor: '#222222' },
        { label: 'Débito', data: this.debito, backgroundColor: '#FB925A' },
        { label: 'Crédito', data: this.credito, backgroundColor: '#FF5700' },
        { label: 'Depósito', data: this.deposit, backgroundColor: '#FFB84C' },
        { label: 'Transferencia', data: this.transfer, backgroundColor: '#FF7043' }
      ]

      const filteredDatasets = rawDatasets.filter(ds => ds.data.some(val => val !== 0))

      return {
        labels: this.labels,
        datasets: filteredDatasets
      }
    },
    chartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top'
          },
          title: {
            display: false
          }
        },
        scales: {
          x: { stacked: true },
          y: { stacked: true }
        }
      }
    }
  }
}
</script>
